import { h6 } from '../typography';

export default {
    root: {
        ...h6,
    },
    sortAction: {
        alignItems: 'center',
        verticalAlign: 'middle',
    },
    fixedHeader: {
        whiteSpace: 'nowrap',
    },
};
